module.exports = __webpack_public_path__ + "../resources/img/ic_night_weather.de9facd1.svg";